(ns app.front.ui.filter-boxes
  (:require ["@carbon/icons-react/es/close--large/16" :default CloseLarge16]
            [app.front.ui :as ui]
            [app.front.ui.select :as ui-select]
            [app.front.util :refer [for-frag] :as futil]
            [core.front.carbon :as cc]))

(defn- filter-box-wrapper [& children]
  (into [:div.bg-ui-light-gray.border.border-solid.border-gray-400.rounded-md.p-4.relative.w-full.sm:min-w-64.max-w-sm.flex-1.flex.flex-col.gap-2
         {:class "[&_.number-input-wrapper]:block [&_.number-input-wrapper]:w-full [&_input]:w-full"}]
        children))


(defn- filter-box-remove-button [tr on-click]
  [:button.border-0.p-2.m-0.absolute.top-0.right-0.bg-transparent
   {:on-click   #(do
                   (-> % .-currentTarget .blur) ;; Prevent focus jumping to the next box
                   (on-click))
    :aria-label (tr [:remove])}
   [:> CloseLarge16]])


(defn filter-box [tr {:keys [id title type on-remove on-change value] :as filter-attrs}]
  (let [input-id     (str id "-input")
        common-attrs {:id         input-id
                      :label-text title
                      :hide-label true
                      :value      value
                      :light      true}]
    [filter-box-wrapper
     [filter-box-remove-button tr on-remove]
     [:label title]
     (case type
       :select
       [ui-select/select (merge common-attrs
                                {:class-name   "w-full"
                                 :allow-empty? true
                                 :select-text  (tr [:select/value])
                                 :values       (:values filter-attrs)
                                 :on-change    on-change
                                 :val->str     (or (:val->str filter-attrs) str)})]
       :text
       [ui/text-input (merge common-attrs
                             {:on-change #(on-change (futil/tval %))})]
       :integer
       [ui/number-input (merge common-attrs
                               {:on-change  #(on-change (-> % futil/tval futil/parse-int))
                                :hide-unit? true
                                :step       1})]
       :decimal
       [ui/number-input (merge common-attrs
                               {:on-change  #(on-change (-> % futil/tval futil/parse-float))
                                :hide-unit? true})]
       :toggle
       (cc/checkbox {:id         input-id
                     :label-text title
                     :checked    (boolean value)
                     :on-change  on-change})
       (:date :date-range)
       [ui/date-picker {:id          input-id
                        :tr          tr
                        :label-text  title
                        :hide-label  true
                        :class-input "!bg-ui-white"
                        :width       "100%"
                        :callback    on-change
                        :value       value}]
       nil)]))


(defn filter-boxes [tr filters]
  [:div.flex.gap-4.flex-wrap.flex-col.sm:flex-row
   (for-frag [filter-attrs filters]
     [filter-box tr filter-attrs])])
